var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVegetables05 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "710.568px",
    height: "777.184px",
    viewBox: "0 0 710.568 777.184",
    enableBackground: "new 0 0 710.568 777.184",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.627,621.011c-2.859-15.434-6.343-37.23-9.053-63.027 c-11.486,8.505-23.705,16.904-36.738,25.143c9.965-177.039-21.25-372.446-65.651-494.803l0,0 c30.747,149.439,50.717,329.952,27.438,494.294C127.444,541.865-17.913,412.742,1.83,275.7C28.088,134.479,128.963,84.71,121.315,0 c109.647,61.057,189.53,132.598,232.448,207.475c126.335-92.618,246.774-63.822,302.864-141.505 C790.732,436.344,676.37,708.417,295.79,650.614c-47.204,48.496-96.777,91.894-147.138,126.57l-42.581-46.494 C161.012,701.261,213.273,663.837,262.627,621.011L262.627,621.011z M377.447,259.617c27.493,81.869,10.146,165.681-60.968,242.592 c2.905,28.44,7.223,50.331,9.224,59.682c116.959-117.78,214.679-262.38,288.613-393.547c-2.189-6.59-4.463-13.225-6.875-19.9 c-41.786,57.854-133.047,33.85-227.39,108.835C379.175,258.055,378.33,258.852,377.447,259.617L377.447,259.617z M614.49,168.836 c-45.575,117.268-136.91,271.062-248.562,404.008C618.645,602.079,697.768,419.455,614.49,168.836z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVegetables05, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vegetables-05.f6325702.svg";
export { ForwardRef as ReactComponent };